<template>
<div v-if="offer">
  <breadcrumb :items="[{ text: offer.name, to: '/editar-oferta/' + offer._id }, { text: 'Ofertas coletivas', to: '/ofertas-coletivas' }, { text: published ? 'Editar oferta coletiva' : 'Cadastrar oferta coletiva', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <div class="row">
      <div class="col-sm-2">
        <product-image v-if="offer" :product="offer.product_variation" :product_variation="offer.product_variation" />
      </div>
      <div class="col-sm-10">
        <h4>{{ product_variation.name }}</h4>
        <span>{{ product_variation.description }}</span>
        <tags :tags="product_variation.tags" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <b-form-group label="Origem do envio *" description="Lugar onde o produto está estocado aguardando para envio">
          <p v-if="form.address">{{form.address.description}}</p>
          <location :cb="setAddress" :current_address="form.address" :autoload="false" />
        </b-form-group>
        <b-form-group label="Condições de entrega *">
          <b-form-select class="form-control" v-model="form.delivery_conditions" :options="delivery_conditions" v-validate="'required'" name="invoice_issuer" />
          <field-error :msg="veeErrors" field="invoice_issuer" />
        </b-form-group>
        <b-form-group label="Destino da entrega *" description="Praça onde será entregue a mercadoria">
          <form-multiple-adresses :form="form" field="delivery_destination" />
          <field-error :msg="veeErrors" field="delivery_destination" />
        </b-form-group>
      </div>
      <div class="col-md-4">
        <div>
          <b-form-group label="Quantidade disponível *">
            <b-form-input v-model="form.qtd" type="number" v-validate="'required'" name="qtd" :max="offer.qtd - offer.qtd_ordered" :disabled="published" />
            <small v-if="form.qtd_ordered > 0">Já vendidos: {{ form.qtd_ordered }}</small>
            <field-error :msg="veeErrors" field="qtd" />
          </b-form-group>
        </div>
        <div>
          <b-form-group label="Quantidade minima por compra *">
            <b-form-input v-model="form.minimum_order" type="number" v-validate="'required'" name="minimum_order" :min="form.minimum_order" :disabled="published" />
            <field-error :msg="veeErrors" field="minimum_order" />
          </b-form-group>
        </div>
      </div>
      <div class="col-md-12">
        <b-form-group label="Condições de compra *" description="Detalhes sobre a compra">
          <form-editor :form="form" field="order_conditions" />
          <field-error :msg="veeErrors" field="delivery_destination" />
        </b-form-group>
      </div>

      <div class="col-md-12">
        <br />
        <h5>PREÇO</h5>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Preço de fábrica *">
              <money v-model="form.supplier_price" class="form-control" v-validate="'required'" name="supplier_price" @input="calcFinalPrice"></money>
              <field-error :msg="veeErrors" field="supplier_price" />
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Frete para Armazém">
              <money v-model="form.shipping_to_warehouse_price" class="form-control" @input="calcFinalPrice"></money>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Impostos">
              <money v-model="form.taxes" class="form-control" @input="calcFinalPrice"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Armazenamento">
              <money v-model="form.storage_percentage" class="form-control" @input="calcFinalPrice" v-bind="{ prefix: '', suffix: ' %' }"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Vendedor">
              <money v-model="form.seller_percentage" class="form-control" @input="calcFinalPrice" v-bind="{ prefix: '', suffix: ' %' }"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Frete/entrega">
              <money v-model="form.shipping_percentage" class="form-control" @input="calcFinalPrice" v-bind="{ prefix: '', suffix: ' %' }"></money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Margem da plataforma">
              <money v-model="form.platform_percentage" class="form-control" @input="calcFinalPrice" v-bind="{ prefix: '', suffix: ' %' }"></money>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Preço final *" description="Valor do produto + impostos + frete" class="bmd-form-group final_price">
              <money v-model="form.final_price" class="form-control" v-validate="'required'" name="final_price"></money>
              <field-error :msg="veeErrors" field="final_price" />
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <form-submit :errors="error" :sending="isSending" :label="
          published
            ? 'Salvar oferta coletiva'
            : 'Publicar oferta coletiva'
        " />
  </b-form>
</div>
</template>

<script>
import axios from "axios";
import FormSubmit from "@/components/FormSubmit";
import ProductImage from "@/components/ProductImage";
import FormMultipleAdresses from "@/components/FormMultipleAdresses";
import FormEditor from "@/components/FormEditor";
import Location from '@/components/Location'
import Tags from "@/components/Tags";
import FieldError from "@/components/FieldError";

export default {
  name: "CollectiveOfferForm",
  data() {
    return {
      delivery_conditions: [
        "A domicílio",
        "Ponto Focal",
        "Estabelecimento Comercial",
      ],
      offer: null,
      product_variation: null,
      published: false,
      form: {
        offer: null,
        qtd: 0,
        qtd_ordered: 0,

        address: null,
        minimum_order: 1,
        order_conditions: "",
        delivery_conditions: "foo",
        delivery_destination: [""],

        total: 0,
        supplier_price: 0,
        taxes: 0,
        shipping_to_warehouse_price: 0,
        storage_percentage: 5,
        seller_percentage: 5,
        shipping_percentage: 5,
        platform_percentage: 6,
        final_price: 0,

        published: true,
      },
    };
  },
  created() {
    this.edit(this.$route.params.id);
  },
  beforeDestroy() {
    if (!this.published) {
      axios.delete("collective_offers/" + this._id);
    }
  },
  methods: {
    edit(id) {
      this.isLoading = true;
      this._id = id;
      axios
        .get("collective_offers/" + id, {
          params: {
            populate: "offer product_variation",
          },
        })
        .then(({
          data
        }) => {
          const {
            offer
          } = data;
          this.offer = offer;
          this.product_variation = offer.product_variation;
          this.published = data.published;
          this.apiDataToForm(this.form, {
            ...offer,
            ...data,
            qtd: offer.qtd - offer.qtd_ordered,
            qtd_ordered: data.qtd_ordered,
            offer: offer._id,
          });
          this.isLoading = false;
        })
        .catch(this.showError);
    },
    save() {
      this.$validator.validate().then((isValid) => {
        if (isValid) {
          this.isSending = true;
          this.error = false;
          axios({
              method: "PUT",
              url: "collective_offers/" + this._id,
              data: this.form,
            })
            .then((resp) => {
              var offer = resp.data;
              if (offer && offer._id) {
                this.published = true
                this.notify("Oferta coletiva publicada com sucesso!");
                window.scrollTo(0, 0);
                this.$router.replace("/ofertas-coletivas");
              }
              this.isSending = false;
            })
            .catch(this.showError);
        }
      });
    },
    calcFinalPrice() {
      var final_price =
        this.form.supplier_price +
        this.form.taxes +
        this.form.shipping_to_warehouse_price;
      if (this.form.storage_percentage && this.form.storage_percentage > 0) {
        final_price +=
          (this.form.supplier_price * this.form.storage_percentage) / 100;
      }
      if (this.form.seller_percentage && this.form.seller_percentage > 0) {
        final_price +=
          (this.form.supplier_price * this.form.seller_percentage) / 100;
      }
      if (this.form.shipping_percentage && this.form.shipping_percentage > 0) {
        final_price +=
          (this.form.supplier_price * this.form.shipping_percentage) / 100;
      }
      if (this.form.platform_percentage && this.form.platform_percentage > 0) {
        final_price +=
          (this.form.supplier_price * this.form.platform_percentage) / 100;
      }
      this.form.final_price = final_price;
    },
    setAddress(address) {
      this.form.address = address
    }
  },
  components: {
    FormSubmit,
    ProductImage,
    FormMultipleAdresses,
    FormEditor,
    Tags,
    FieldError,
    Location
  },
};
</script>
<style lang="sass" scoped>
.thumb
  max-width: 100%
  max-height: 120px
.final_price
  font-size: 14px
  font-weight: bold
  input
    font-size: 18px
</style>
